<template>
  <div>
    <form class="form">
      <div class="row">
        <h2 style="color:#0892D0; font-weight: 600;">
          Arnergy Lux Devices
          <hr />
        </h2>
      </div>
      <div class="row top_container">
        <div class="device_ID">
          <label style="color:#0892D0;" for="deviceID"
            >Choose a Device ID</label
          >
          <input
            type="number"
            name="deviceId"
            id="deviceId"
            v-model="regparams.deviceId"
            placeholder="Select a DeviceId"
            class="form-control form-control-lg"
          />
          <!-- <select
            name="deviceId"
            id="deviceId"
            v-model="regparams.deviceId"
            class="form-control"
            required
          >
            <option value="" disabled selected hidden>Select a DeviceId</option>
            <option
              v-for="(values, key) in unmappedDeviceIdList"
              :value="values"
              >{{ values }}</option
            >
          </select> -->
        </div>
        <!-- Pick one or more Serial Number -->
        <div class="serial_number">
          <label style="color:#0892D0;" for="lux_serial_number"
            >Pick one or more Lux Serial Number</label
          >
          <input
            type="number"
            name="searchTerm"
            id="searchTerm"
            class="form-control"
            v-model="searchTerm"
            :onkeyup="searchTable"
          />
          <select
            name="lux_serial_number"
            id="lux_serial_number"
            v-model="regparams.serialNumbers"
            multiple
            size="2"
            class="form-control"
          >
            <option
              v-for="(values, keys) in unmappedSerialNumberList"
              :key="keys"
              :value="values"
              >{{ values }}</option
            >
          </select>
        </div>
        <!-- Payment type -->
        <div class="payment_type">
          <label style="color:#0892D0;" for="payment_type"
            >Select Payment Type</label
          >
          <select
            name="payment_type"
            id="payment_type"
            v-model="regparams.paymentType"
            placeholder="Select a payment type"
            class="form-control form-control-lg"
            required
          >
            <option value="" disabled selected hidden
              >Select a Payment Type</option
            >
            <option value="OS">Outright Sale (OS)</option>
            <option value="LO">Lease to Own (LO)</option>
            <option value="ES">ENERGY AS A SERVICE (ES)</option>
          </select>
        </div>
      </div>
      <div class="row lux_payment">
        <!-- Select Device Version -->
        <div class="col-md-6">
          <label style="color:#0892D0;" for="device_version"
            >Select Device Version</label
          >
          <select
            name="device_version"
            id="device_version"
            v-model="regparams.Version"
            placeholder="Version _"
            class="form-control form-control-lg"
            required
          >
            <option value="" disabled selected hidden
              >Select a Device Version</option
            >
            <option value="v3">System Version 3</option>
            <option value="v5">System Version 5</option>
            <option value="v6">System Version 6</option>
            <option value="v7">System Version 7</option>
          </select>
        </div>
        <!-- Enter CLoad Value -->
        <div class="col-md-6">
          <label style="color:#0892D0;" for="CLoad">Enter CLoad Value</label>
          <input
            type="number"
            name="Cload"
            id="Cload"
            v-model="regparams.CLoad"
            placeholder="Contractual Load"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <div class="row luxMisc">
        <!-- CID -->
        <div class="col-md-6">
          <label style="color:#0892D0;" for="CID">Device CID</label>
          <input
            type="number"
            name="CID"
            id="CID"
            v-model="regparams.MiscData.CID"
            placeholder="CID"
            class="form-control form-control-lg"
          />
        </div>
        <!-- Exptd. Charge Cycle -->
        <div class="col-md-6">
          <label style="color:#0892D0;" for="E_charge_cycle"
            >Exptd. Charge Cycle</label
          >
          <input
            type="number"
            name="E_charge_cycle"
            id="E_charge_cycle"
            v-model="regparams.MiscData.ExptdChgCyl"
            placeholder="Expected Charge Cycle"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <div class="row luxDifferentials">
        <!-- LUX TYPE -->
        <div class="col-md-6">
          <label style="color:#0892D0;" for="luxType"
            >Select LUX Device Type</label
          >
          <select
            name="luxType"
            id="luxType"
            v-model="regparams.MiscData.systemDeviceType"
            placeholder="Select a LUX Device Type"
            class="form-control form-control-lg"
            required
          >
            <option value="" disabled selected hidden
              >Select a LUX Device type</option
            >
            <option
              v-for="(values, key) in typesOfLuxDevices"
              :value="values"
              :key="key"
              >{{ values }}</option
            >
          </select>
        </div>
        <!-- Battery Capacity -->
        <div class="col-md-6">
          <label style="color:#0892D0;" for="batCap">Battery Capacity</label>
          <input
            type="number"
            name="batCap"
            id="batCap"
            v-model="regparams.batCapacity"
            placeholder="Battery Capacity"
            class="form-control form-control-lg"
          />
        </div>
      </div>
      <!-- Button -->
      <hr style="width: 98%; margin-left: auto; margin-right: auto;" />
      <div class="row button_style">
        <button
          type="button"
          class="btn btn-primary btn-lg col-md-12"
          @click="submit"
        >
          Enter
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { isEmpty } from "element-ui/src/utils/util";
export default {
  name: "LuxDeviceUpdate",
  data() {
    return {
      searchTerm: "",
      unmappedDeviceIdList: [],
      unmappedSerialNumberList: [],
      typesOfLuxDevices: ["OPU", "SNA", "INA"],
      regparams: {
        deviceId: "",
        serialNumbers: [],
        paymentType: "",
        CLoad: "",
        Version: "",
        batCapacity: "",
        MiscData: {
          CID: "",
          ExptdChgCyl: "",
          systemDeviceType: ""
        }
      },
      errorsResult: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    async searchTable() {
      if (this.searchTerm.length == 0) {
        await this.unmappedSerialNumber();
      } else {
        this.unmappedSerialNumberList = this.unmappedSerialNumberList.filter(
          item => item.toLowerCase().includes(this.searchTerm)
        );
      }
    }
  },
  methods: {
    validateReg() {
      let errors = [];
      for (let [field, value] of Object.entries(this.regparams)) {
        value = value + "";
        if (value !== null && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "serialNumbers":
            if (value === [] || value === NaN || isEmpty(value)) {
              errors[field] = "Serial Number cannot be empty.";
            }
            break;
          case "paymentType":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Payment type cannot be empty.";
            }
            break;
          case "CLoad":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Contractual Load cannot be empty.";
            }
            break;
          case "batCapacity":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Battery capacity cannot be empty.";
            }
            break;
          case "Version":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "Device version cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      for (let [field, value] of Object.entries(this.regparams.MiscData)) {
        value = value + "";
        if (value !== null && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "CID":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "CID cannot be empty.";
            }
            break;
          case "ExptdChgCyl":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Expected Charge cycle cannot be empty.";
            }
            break;
          case "systemDeviceType":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "Device Type cannot be empty.";
            }
            break;
          default:
            break;
        }
        this.errorsResult = errors;
      }
    },
    async unmappedDeviceID() {
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      const url = `/devices/get-installation/681`;
      LuxHTTP.get(url)
        .then(response => {
          this.unmappedDeviceIdList = response.data.data;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    },
    async unmappedSerialNumber() {
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      const url = `/inverters/unmapped_inverters`;
      LuxHTTP.get(url)
        .then(response => {
          this.unmappedSerialNumberList = response.data.data;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    },

    submit() {
      this.validateReg();
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }
      console.log("this.regparams", this.regparams);
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      let url = `/devices/`;
      LuxHTTP.post(url, this.regparams)
        .then(response => {
          console.log("response", response);
          this.showSuccessMsg({ message: "Device setup successfully!" });
          location.reload();
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    }
  },
  async mounted() {
    await this.unmappedSerialNumber();
    await this.unmappedDeviceID();
  }
};
</script>

<style scoped>
.form {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.row label {
  font-size: 12px;
}
.top_container {
  display: grid;
  grid:
    "devicesID devicesID devicesID devicesID serialNumber serialNumber"
    "paymentType paymentType paymentType paymentType serialNumber serialNumber";
  grid-gap: 10px;
  padding: 10px;
}
.device_ID {
  grid-area: devicesID;
}
.device_ID input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.serial_number {
  grid-area: serialNumber;
}
.serial_number select {
  min-height: 130px !important;
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.payment_type {
  grid-area: paymentType;
  font-family: sans-serif;
  padding-top: 18px;
}
.payment_type select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}

.lux_payment {
  font-family: sans-serif;
  /* padding-top: 18px; */
}
.lux_payment select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.luxDifferentials select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.luxDifferentials input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.lux_payment input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.luxMisc {
  font-family: sans-serif;
  /* padding-top: 18px; */
}
.luxMisc input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.button_style {
  font-family: sans-serif;
  width: 98%;
  margin-right: auto;
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/LuxSetup.vue